import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import Dashboard from "./pages/Dashboard";
import PostNeed from "./pages/PostNeed";
import OfferHelp from "./pages/OfferHelp";
import Volunteer from "./pages/Volunteer";
import Jobs from "./pages/Jobs";
import Food from "./pages/Food";
import Mentorship from "./pages/Mentorship";
import Stats from "./pages/Stats";
import Pitch from "./pages/Pitch";
import Certificate from "./pages/Certificate";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<AuthPage mode="login" />} />
              <Route path="/signup" element={<AuthPage mode="signup" />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/post-need" element={<PostNeed />} />
              <Route path="/offer-help" element={<OfferHelp />} />
              <Route path="/volunteer" element={<Volunteer />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/food" element={<Food />} />
              <Route path="/mentorship" element={<Mentorship />} />
              <Route path="/stats" element={<Stats />} />
              <Route path="/pitch" element={<Pitch />} />
              <Route path="/certificate" element={<Certificate />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
